export function getModuleApi(module_name) {
  const globalInface = typeof window === 'object' ? window : global
  return globalInface && globalInface.modules && globalInface.modules[module_name] && globalInface.modules[module_name].apis ? globalInface.modules[module_name].apis : {}
}

export default getModuleApi